module.exports = __webpack_public_path__ + "img/logo.2057448b.png";